import {
    FaUsers, FaTrashAlt, FaEye, FaArrowRight, FaPen, FaClock, FaMedal, FaBullseye, FaBookOpen,
    FaBoxOpen, FaLaptop, FaUpload, FaBookmark, FaPlus,
} from "react-icons/fa";
import { CiSearch, CiClock2 } from "react-icons/ci";
import { IoIosSettings, IoIosArrowBack } from "react-icons/io";
import { FiTrash2, FiDownload } from "react-icons/fi";
import { BiWorld } from "react-icons/bi";
import { CiCircleInfo } from "react-icons/ci";
import { ImCross } from "react-icons/im";
import { HiRefresh } from "react-icons/hi";
import { GoFileDirectoryFill } from "react-icons/go";


const icons = {
    search: CiSearch,
    clock: CiClock2,
    users: FaUsers,
    trash: FaTrashAlt,
    eye: FaEye,
    settings: IoIosSettings,
    right: FaArrowRight,
    pen: FaPen,
    back: IoIosArrowBack,
    world: BiWorld,
    clock: FaClock,
    users: FaUsers,
    medal: FaMedal,
    info: CiCircleInfo,
    bullseye: FaBullseye,
    bookOpen: FaBookOpen,
    boxOpen: FaBoxOpen,
    laptop: FaLaptop,
    upload: FaUpload,
    bookmark: FaBookmark,
    plus: FaPlus,
    trashAlt: FaTrashAlt,
    cross: ImCross,
    trash2: FiTrash2,
    download: FiDownload,
    restore:HiRefresh,
    file:GoFileDirectoryFill,
};
export default icons;